<template>
	<div class="SubmitProjects">
		<div class="SubmitProjects-header">
			<button class="SubmitProjects-header-toggle" @click="toggleExpanded">
				<CloIcon v-if="expanded" symbol="triangleDown" />
				<CloIcon v-else symbol="triangleRight" />
				<CloHeading level="2" size="3">{{ $t('project.chooseProject') }}</CloHeading>
			</button>
			<p class="SubmitProjects-header-info">{{ $t('project.chooseProjectDesc') }}</p>
		</div>
		<!-- Your Projects toggleable panel -->
		<div v-show="expanded" class="SubmitProjects-all">
			<CloHeading level="3" size="4" class="u-stack-sm">{{ $t('project.myProjects') }}</CloHeading>
			<ul v-if="myProjects" class="SubmitProjects-all-list">
				<li v-for="(project, index) in myProjects" v-bind:key="index">
					<!-- TODO: Figure out how to handle these selections as form elements? -->
					<div class="InputCheckbox InputCheckbox--lg InputCheckbox--styled">
						<input
							type="checkbox"
							:name="project.name"
							:id="project.id"
						/>
						<label :for="project.id"><span class="is-visuallyHidden">{{ project.name }}</span></label>
					</div>
					<ProjectCard 
						:id="project.id" 
						:name="project.name" 
						:imgPath="project.imgPath" 
						:imgTitle="project.imgTitle"
						:imgAlt="project.imgAlt"
						:baseUrl="baseUrl"
						/>
				</li>
			</ul>
			<p v-else class="u-margin-none">{{ $t('project.myProjectsEmpty') }}</p>
			<!-- TODO: Add help center link destination -->
			<a href="#" class="Button Button--small Button--hollow u-margin-none">{{ $t('project.learnMore')}}</a>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import ProjectCard from './ProjectCard.vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
import CloInputCheckbox from '@/forms/CloInputCheckbox/CloInputCheckbox.vue';

export default ({
	name: 'SubmitProjects',
	components: {
		ProjectCard,
		CloHeading,
		CloIcon,
		CloInputCheckbox,
	},
	props: {
		choose: {
			type: Boolean,
			default: true,
		},
		baseUrl: {
			type: String,
			default: 'https://ebird.org',
		}
	},
	data() {
		return {
			expanded: false,
			myProjects: [
				{
					id: 1,
					name: 'Project Sapsucker',
					imgPath: 'https://clo-brand-static-prod.s3.amazonaws.com/logos/ebird/project/project-sapsucker-project-image.jpg',
					imgTitle: 'Project Sapsucker',
					imgAlt: 'Project Sapsucker logo',
				},
				{
					id: 2,
					name: 'International Shorebird Survey',
					imgPath: 'https://clo-brand-static-prod.s3.amazonaws.com/logos/ebird/project/iss-project-image.jpg',
					imgTitle: 'International Shorebird Survey',
					imgAlt: 'International Shorebird Survey logo',
				},
				{
					id: 3,
					name: 'Bird Conservation Network (BCN)',
					imgPath: 'https://clo-brand-static-prod.s3.amazonaws.com/logos/ebird/project/bcn-project-image.jpg',
					imgTitle: 'Bird Conservation Network (BCN)',
					imgAlt: 'Bird Conservation Network (BCN) logo',
				},
			],
		};
	},
	mounted() {
	},
	methods: {
		toggleExpanded() {
			this.expanded = !this.expanded;
		}
	},
});

</script>

<style lang="scss">
.SubmitProjects{
	background-color: $brand-color-forest-green-3;
	@include inset-md;
	border-radius: $space-md;
	@include stack-responsive;
	display: flex;
	flex-direction: column;
	row-gap: $space-md;
	@include underlineLinksOnHover;
	@include breakpoint(medium) {
		@include inset-squish-lg;
	}
}

.SubmitProjects-header {
	display: flex;
	flex-wrap: wrap;
	column-gap: $space-md;
	@include breakpoint(medium) {
		column-gap: $space-lg;
	}
	&-toggle {
		flex: 0 0 auto;
		display: flex;
		align-items: center;
		column-gap: $space-xs;
		.Heading, .Icon {
			@include link;
			transition: transform 200ms ease-in-out;
		}
		text-underline-offset: $space-rel-xs;
		text-decoration-line: underline;
		text-decoration-style: solid;
		text-decoration-thickness: $space-xxs;
		@include interactiveColor(text-decoration-color, transparent, $color-link-hover);
	}
	&-info {
		flex: 1 1 32rem;
		@include text(3);
		margin: 0;
		@include breakpoint(medium) {
			@include text(4);
		}
	}
	&-list {
		list-style: none;
		margin: 0;
		display: flex;
		row-gap: $space-xs;
		column-gap: $space-md;
		flex-wrap: wrap;
	}
}

.SubmitProjects-all {
	&-list {
		list-style: none;
		margin: 0 0 $space-md 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		row-gap: $space-sm;
		li {
			display: flex;
			align-items: center;
			column-gap: $space-sm;
		}
	}
}

.SubmitProjects.SubmitProjects--selected {
	@include inset-squish-md;
	@include stack-md;
	.SubmitProjects-header {
		align-items: center;
		column-gap: $space-md;
		row-gap: $space-sm;
		.Heading {
			margin: 0;
		}
		&-link {
			margin-inline-start: auto;
			@include link;
		}
	}
}
</style>
